import { cloneDeep, concat, forEach, indexOf, map, remove } from 'lodash'
import { setupIndeterminateCheckbox } from './checkNode-service'

const changeUserPrefByProperty = (property, userPref) => {
  const idsArray = []

  const traverse = function (current) {
    forEach(current, (item) => {
      const userPrefIndex = indexOf(userPref, item.id)

      if (userPrefIndex !== -1) {
        idsArray.push([item.id])
      }

      if (item.isParent) {
        traverse(item.children)
      }
    })
  }

  traverse(property.children)

  return remove(userPref, (item) => indexOf(idsArray, item) !== -1)
}

const traverseChecked = function (current, bool) {
  map(current, (item) => {
    item.checked = bool
    item.indeterminate = false

    if (item.isParent) {
      traverseChecked(item.children, bool)
    }
  })
}

const hasDescendantInPref = (node, userPref) => {
  if (!userPref || !userPref.length) {
    return false
  }
  if (userPref.indexOf(node.id) !== -1) {
    return true
  }
  if (node.children && node.children.length) {
    return node.children.some((child) => hasDescendantInPref(child, userPref))
  }
  return false
}

const prepareLocationTree = (params, userPrefCurrent, isAllSelected) => {
  const { nodes, finalNode } = params
  const userPref = userPrefCurrent

  const nodeList = concat([], nodes.children)
  const propertyId = nodes.id

  const traverse = function (current) {
    map(current, (item) => {
      item.isParent = item.children && !!item.children.length
      item.propertyId = propertyId

      const isSelectedInUserPref = !!(
        userPref &&
        userPref.length &&
        userPref.indexOf(item.id) !== -1
      )

      item.checked = nodes.indeterminate
        ? !!(
            nodes.checked ||
            item.checked ||
            isSelectedInUserPref ||
            isAllSelected
          )
        : nodes.checked
      item.expanded = item.checked

      if (finalNode && item.locationType === finalNode) {
        item.isParent = false
        item.children = []
      } else if (item.isParent) {
        if (item.checked) {
          traverseChecked(item.children, true)
        }
        traverse(item.children)
      }
    })
  }

  traverse(nodeList)

  setupIndeterminateCheckbox(nodeList)

  return nodeList
}

const prepareProperties = (params, userPrefCurrent, isAllSelected) => {
  const { nodes } = params
  const userPref = userPrefCurrent || []
  const properties = concat([], nodes.children || [])

  map(properties, (item) => {
    item.isParent = item.children && !!item.children.length
    item.isBuildingsPrepared = false

    const isSelectedInUserPref =
      userPref.length && userPref.indexOf(item.id) !== -1
    item.checked = !!(item.checked || isSelectedInUserPref || isAllSelected)
    item.indeterminate =
      !item.checked && !isAllSelected && hasDescendantInPref(item, userPref)
    item.expanded = false
  })

  return properties
}

const changeExpanded = (value, locations) => {
  const traverse = function (current) {
    map(current, (item) => {
      if (item.id === value) {
        item.expanded = !item.expanded
      }

      if (item.isParent) {
        traverse(item.children)
      }
    })
  }

  traverse(locations)
}

const getAllSelectedState = (nodes) => nodes.every((item) => item.checked)

const buildPropertyTree = (state, index) => {
  const { nodes, isAllSelected, userPrefCurrent, finalNode } = state
  const expandedProperty = cloneDeep(nodes[index])

  expandedProperty.expanded = !expandedProperty.expanded

  if (!expandedProperty.isBuildingsPrepared) {
    const newPropertyChildren = prepareLocationTree(
      {
        nodes: expandedProperty,
        finalNode,
      },
      userPrefCurrent,
      isAllSelected
    )

    expandedProperty.children = newPropertyChildren
    expandedProperty.isBuildingsPrepared = true
  }

  return expandedProperty
}

export {
  getAllSelectedState,
  changeExpanded,
  prepareProperties,
  buildPropertyTree,
  changeUserPrefByProperty,
}
